var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',{staticClass:"ma-0"},[_vm._t("default"),(!_vm.loader)?_c('Footer'):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }